<ng-container *ngIf="layout === 'stacked'">
  <p class="text-2xl font-semibold mb-1">{{ currentNodeLabel }}</p>
  <p class="pa-crumbs text-secondary text-sm mb-6" *ngIf="breadcrumb">
    {{ breadcrumb }} — ● = famille avec configuration explicite
  </p>
</ng-container>

<mat-progress-bar *ngIf="loadingResolve" mode="indeterminate" color="primary" class="mb-4"></mat-progress-bar>

<form [formGroup]="form" *ngIf="!loadingResolve && resolved">
  <!-- grid : colonnes côte à côte, comme la card « Acteurs par défaut » de l'ancien écran -->
  <div [ngClass]="{ 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-6 items-start': layout === 'grid' }">
    <div class="pa-role" [class.pa-role--grid]="layout === 'grid'" *ngFor="let role of allRoles">
      <div class="pa-role-head">
        <label>{{ roleLabels[role] }}</label>
        <span class="pa-badge" [ngClass]="roleBadgeClass(role)">{{ roleBadgeLabel(role) }}</span>
      </div>

      <!-- Option A : champ TOUJOURS éditable, pré-rempli des valeurs résolues (héritées
           comprises). La surcharge = un DIFF avec l'héritage, calculé à l'enregistrement.
           Le ngFor-epoch force la recréation du champ (le composant partagé ne sait pas
           être désélectionné de l'extérieur : reset héritage / changement de famille). -->
      <!-- Maquette d'estimation « action d'équipe » : équipe fictive désignée en Validateurs N+1. -->
      <team-action-mock-purchase-actor-team
        *ngIf="scope === 'establishment' && role === PurchaseActorRoleEnum.REFERENTS_N1"
      ></team-action-mock-purchase-actor-team>

      <ng-container *ngIf="isMultiRole(role); else approverField">
        <ng-container *ngFor="let epoch of [roleFieldEpoch[role] || 0]">
          <base-form-input
            [label]="roleLabels[role]"
            [controlName]="role"
            type="search-multiple"
            appearance="outline"
            [items$]="roleItems$[role]"
            [preSelectedElement]="rolePreselected[role]"
            [chipsInField]="true"
            displayProperty="fullName"
            [withoutPadding]="true"
            (autocompleteChange)="searchRoleUsers(role, $event)"
            [disabled]="!canModify"
          ></base-form-input>
        </ng-container>
      </ng-container>

      <!-- disableAutoSelect : sans lui, base-form-input sélectionne d'office l'unique candidat
           d'un champ vide — le formulaire passait sale sans saisie et l'enregistrement aurait
           stocké cet approbateur sur le nœud. -->
      <ng-template #approverField>
        <ng-container *ngFor="let epoch of [roleFieldEpoch[role] || 0]">
          <base-form-input
            [label]="roleLabels[role]"
            [controlName]="role"
            type="autocomplete"
            appearance="outline"
            [items$]="roleItems$[role]"
            [disableAutoSelect]="true"
            displayProperty="fullName"
            [withoutPadding]="true"
            (autocompleteChange)="searchRoleUsers(role, $event)"
            [disabled]="!canModify"
          ></base-form-input>
        </ng-container>
      </ng-template>

      <button
        mat-button
        class="pa-link-btn"
        *ngIf="canResetRole(role)"
        [permissionBlock]="modifyPermissions"
        (click)="resetRole(role)"
      >
        {{ resetRoleLabel(role) }}
      </button>

      <!-- Invariant PRED-3207 aménagé : forcé ON si l'approbateur est défini sur ce nœud,
           forcé OFF sans approbateur effectif ; éditable (opt-out/réactivation par famille)
           uniquement quand l'approbateur est hérité. -->
      <ng-container *ngIf="role === PurchaseActorRoleEnum.APPROVER">
        <div class="mt-2 pa-role-head">
          <!-- Verrou piloté par le FormControl (enforceAutorizationOrderCoherence), pas par [disabled]. -->
          <mat-slide-toggle formControlName="autorizationOrder">Autorisation sans commande</mat-slide-toggle>
          <span class="pa-badge" [ngClass]="autorizationOrderBadgeClass()">
            {{ autorizationOrderSourceLabel() }}
          </span>
          <button
            mat-button
            class="pa-link-btn"
            *ngIf="!authorizationToggleDisabled && autorizationOrderDiffersFromInherited"
            [permissionBlock]="modifyPermissions"
            (click)="revertAutorizationOrder()"
          >
            Réinitialiser
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</form>

<!-- Annuler / Enregistrer simples (calque Supervision métier) : le choix de propagation
     aux sous-familles est demandé PAR MODALE au moment de l'enregistrement. -->
<div class="pa-actions-row" *ngIf="dirty || hasExplicitConfig">
  <button
    mat-button
    class="pa-danger-btn mr-auto"
    *ngIf="hasExplicitConfig"
    [permissionBlock]="modifyPermissions"
    (click)="unassignConfig()"
  >
    Retirer la configuration
  </button>
  <ng-container *ngIf="dirty">
    <button mat-button (click)="cancelEdits()">Annuler</button>
    <button
      mat-raised-button
      color="primary"
      [permissionBlock]="modifyPermissions"
      [disabled]="saving"
      (click)="save()"
    >
      Enregistrer
    </button>
  </ng-container>
</div>
